import  { useEffect, useState } from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Toolbar,
  AppBar,
  Typography,
  Box,
  CssBaseline,
  Tooltip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
// import { BsRobot } from "react-icons/bs";
import SettingsIcon from '@mui/icons-material/Settings';
// import { MdContactMail } from "react-icons/md";
// import { FaUserGroup } from "react-icons/fa6";
// import { MdInsights } from "react-icons/md";
import { useNavigate, Routes, Route, useLocation, Navigate } from 'react-router-dom';
// import { MdSupportAgent } from "react-icons/md";
import * as MdIcons from "react-icons/md";
import * as Fa6Icons from "react-icons/fa6";
import * as BsIcons from "react-icons/bs";
import ProfileOverlay from '../../Profile/ProfileOverlay';
import Notification from '../Notification';

import Settings from '../Settings/Settings';
import Dashboard from '../Dashboard/Dashboard';
// import Home from '../Home/Home';
import ChannelDetails from '../ChannelDetails/ChannelDetails';
import Analytics from '../Analytics/Analytics';
import UserManagement from '../Usermanagement/UserManagement';
import ViewProfile from '../../Profile/ViewProfile';
import MultiSelectWithDisplay from '../ChannelDetails/InputDetails';
import ChatApp from '../Connect/Connect';
import BuilderPage from '../ChatAssist/BuilderPage';
import { useSocket } from '../../Socket/SocketIo';
import BotConfig from '../Dashboard/BotConfig';
import axiosInstance from '../../../utils/axiosInstance';
import { fetchrolesbyusers } from '../../shared/ApiEndpoint';
import { currentUserRole } from '../../shared/shared';
const drawerWidth = 200;
const collapsedWidth = 60;

export default function CollapsibleNavbar() {
  const {allMessages}= useSocket()
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [notifCount, setNotifCount] = useState(0);
  const [menuItems, setMenuItems] = useState([{
    menu_id:0,
    menu_name:"",
    path:"",
    icon:{lib:"",icon:""}
  }]);

  const toggleDrawer = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(()=>{
    fetchmenus()
  },[])

  useEffect(() => {
  if (!allMessages || allMessages.length === 0) return;

  const latest = allMessages[allMessages.length - 1];

  if (latest.event === "channel_message") {
    const { message } = latest.data;

    // Based on message type
    if (message?.type === "message") {

        setNotifCount(prev => prev + 1);
    } else if (message?.type === "request") {
      setNotifCount(prev => prev + 1);
    }
  }
}, [allMessages]);

const iconLibraries = {
  "react-icons/md": MdIcons,
  "react-icons/fa6": Fa6Icons,
  "react-icons/bs": BsIcons,
};

const getIcons = (iconLib, iconName, size = 24) => {
  if (!iconLib || !iconName) return null; // defensive check

  const lib = iconLibraries[iconLib];
  if (!lib) return null;

  const IconComponent = lib[iconName];
  if (!IconComponent) return null;

  return <IconComponent size={size} />;
};

const fetchmenus =async()=>{
  try {
    const res = await axiosInstance.get(fetchrolesbyusers,{params: { role_id:currentUserRole }, withCredentials:true})
    if (res.status===200){
      const data = res?.data;
      setMenuItems(data)
      console.log(data,"incoming")
    }
  } catch (error) {
    console.error(error)
  }
} 
console.log(menuItems,"menuItems")
   
console.log(currentUserRole,"currentUserRole")
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 , backgroundColor: '#216DB4', }} >
        <Toolbar className="w-100 d-flex align-items-center">
  <IconButton color="inherit" edge="start" onClick={toggleDrawer} className="me-2">
    <MenuIcon />
  </IconButton>

<Box className="flex-grow-1 d-flex align-items-center">
  <img src="/assets/images/Logo.png" alt="Logo"/>
  <Typography variant="subtitle2" noWrap component="div">
    Floassist
  </Typography>
</Box>



  {/* Notification Icon aligned to right using Bootstrap */}
  <Notification notifCount={notifCount}/>
  <IconButton color="inherit" className="ms-2" onClick={() => navigate('/settings')}>
    <SettingsIcon />
  </IconButton>

 <ProfileOverlay/>

</Toolbar>

      </AppBar>

      <Drawer
        variant="permanent"
        sx={{
          width: isOpen ? drawerWidth : collapsedWidth,
          flexShrink: 0,
          whiteSpace: 'nowrap',
          '& .MuiDrawer-paper': {
            width: isOpen ? drawerWidth : collapsedWidth,
            transition: 'width 0.3s',
            overflowX: 'hidden',
          },
        }}
      >
        <Toolbar />
        <List className='globalCursor'>
          {menuItems.map((item, index) => (
            <Tooltip title={!isOpen ? item?.menu_name : ''} placement="right" key={index}>
              <ListItem button sx={{ px: 2 ,backgroundColor: location.pathname.startsWith(item?.path) ? 'rgba(255, 255, 255, 0.1)' : 'transparent'}} onClick={() => navigate(item.path)} >
                <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center',color: location.pathname.startsWith(item?.path) ? '#216DB4' : 'inherit', }}>
                  {/* {item.icon} */}
                  {getIcons(item?.icon?.lib, item?.icon?.icon, 24)}
                </ListItemIcon>
                {isOpen && (
                  <ListItemText
                    primary={item?.menu_name}
                   sx={{ ml: 2, color: location.pathname.startsWith(item?.path) ? '#216DB4' : 'inherit' }}
                    primaryTypographyProps={{ noWrap: true }}
                  />
                )}
              </ListItem>
            </Tooltip>
          ))}
        </List>
      </Drawer>

      {/* Main Content */}
      {/* <Box component="main" sx={{ flexGrow: 1, p: 3 }}> */}
        <Box
  component="main"
  sx={{
    flexGrow: 1,
    p: 3,
    overflowX: 'auto',
    overflowY: 'auto',
    width: '100%',
  }}
>

        <Toolbar />
        {/* 🔁 Routed Content goes here */}
        <Routes>
          {/* <Route path="/" element={<Home />} /> */}
           <Route path="/" element={<Navigate to="/bots" replace />} />
          <Route path="/bots" element={<Dashboard/>} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/analytics" element={<Analytics/>} />
          <Route path="/channeldetails" element={<ChannelDetails/>} />
          <Route path="/usermanagement" element={<UserManagement/>} />
           <Route path="/viewprofile" element={<ViewProfile/>} />
           <Route path="/channeldetails/input" element={<MultiSelectWithDisplay/>} />
           <Route path="/connect" element={<ChatApp/>} />
            <Route path="/bots/createBot" element={<BuilderPage/>} />
            <Route path='/bots/botConfig' element={<BotConfig/>}/>
        </Routes>
      </Box>
    </Box>
  );
}
